import Date       from "../fundamentals/date/Date";
import TimePeriod from "../fundamentals/date/TimePeriod";

class ReservationDetail {
  constructor(
    private readonly _date: Date = new Date(),
    private readonly _timePeriod: TimePeriod = new TimePeriod(),
  ) {
  }

  get date() {
    return this._date;
  }

  get timePeriod() {
    return this._timePeriod;
  }
}

export default ReservationDetail;
